import star from "../Image/Rectangle26.png"
import moon from "../Image/Rectangle27.png"
import toon from "../Image/Rectangle28.png"

const hotelData = [{
        "name": "Light bright airy stylish apt & safe peaceful stay",
        "guests": "4",
        "bedrooms": "2",
        "beds": "2",
        "baths": "2",
        "facilities": "Wif Air conditioning Kitchen. Cancellation fexibility availiable",
        "rating": "4.9",
        "reviewed": "20",
        "shift": "night",
        "price": "34",
        "totalPrice": "167",
        "image": `${star}`,
        "key": "HTLKH345"
    },
    {
        "name": "Apartment in Lost Panorama",
        "guests": "3",
        "bedrooms": "2",
        "beds": "3",
        "baths": "2",
        "facilities": "Wif Air conditioning Kitchen. Cancellation fexibility availiable",
        "rating": "4.8",
        "reviewed": "10",
        "shift": "night",
        "price": "52",
        "totalPrice": "210",
        "image": `${moon}`,
        "key": "HTLKH9455"
    },
    {
        "name": "AR Lounge & Pool (r&r + b&b)",
        "guests": "4",
        "bedrooms": "3",
        "beds": "4",
        "baths": "2",
        "facilities": "Wif Air conditioning Kitchen. Cancellation fexibility availiable",
        "rating": "4.9",
        "reviewed": "25",
        "shift": "day",
        "price": "44",
        "totalPrice": "197",
        "image": `${toon}`,
        "key": "HTLKH3224"
    },
]

export default hotelData;